export interface PublicChatMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

export interface PublicChatRequest {
  message: string;
  chatHistory: PublicChatMessage[];
}

export interface PublicChatResponse {
  response: string;
  updatedChatHistory: PublicChatMessage[];
}

const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

class PublicChatApiService {
  async sendMessage(request: PublicChatRequest): Promise<PublicChatResponse> {
    const response = await fetch(`${API_BASE_URL}/PublicChat/SendMessage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to send message');
    }

    return await response.json();
  }

  async sendAudio(audioFile: File, chatHistory: PublicChatMessage[]): Promise<PublicChatResponse> {
    const formData = new FormData();
    formData.append('audioFile', audioFile);
    
    if (chatHistory.length > 0) {
      formData.append('chatHistoryJson', JSON.stringify(chatHistory));
    }

    const response = await fetch(`${API_BASE_URL}/PublicChat/SendAudio`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to send audio');
    }

    return await response.json();
  }

  async clearChatHistory(): Promise<{ message: string }> {
    const response = await fetch(`${API_BASE_URL}/PublicChat/ClearChatHistory`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to clear chat history');
    }

    return await response.json();
  }
}

export const publicChatApi = new PublicChatApiService();
